/* Prom Dollz — product gallery on desktop: thumbnails down the side, one large photo, arrows.
   The large photo is the same swipeable row of slides phones use (theme.js keeps its dots, colour jumps and
   zoom); this adds the thumbnails and arrows. Thumbnails find their slide by media id, because choosing a
   colour on desktop moves that colour's photo to the front of the row (Gallery.goToColor in theme.js). */
(function () {
  'use strict';
  [].forEach.call(document.querySelectorAll('[data-gallery]'), function (gallery) {
    if (gallery.pdThumbs) return;
    gallery.pdThumbs = true;
    var track = gallery.querySelector('[data-gallery-track]');
    var strip = gallery.querySelector('[data-gallery-thumbs]');
    if (!track || !strip) return;
    var thumbs = [].slice.call(strip.querySelectorAll('[data-thumb]'));
    var count = gallery.querySelector('[data-gallery-count-current]');

    function slides() { return [].slice.call(track.children); }
    function current() { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
    function show(i, instant) {
      var count = slides().length;
      if (!count) return;
      i = (i + count) % count;
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
    }

    function mark() {
      if (count) count.textContent = current() + 1;
      var slide = slides()[current()];
      var id = slide && slide.getAttribute('data-media-id');
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-thumb') === id;
        t.classList.toggle('is-active', on);
        if (on) {
          t.setAttribute('aria-current', 'true');
          // keep the highlighted thumbnail in view inside the strip, without moving the page
          var top = t.offsetTop - strip.offsetTop;
          if (top < strip.scrollTop) strip.scrollTop = top;
          else if (top + t.offsetHeight > strip.scrollTop + strip.clientHeight) strip.scrollTop = top + t.offsetHeight - strip.clientHeight;
        } else {
          t.removeAttribute('aria-current');
        }
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-thumb');
        var i = slides().findIndex(function (s) { return s.getAttribute('data-media-id') === id; });
        if (i > -1) show(i);
      });
    });
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current() + 1); });

    var timer = null;
    track.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(mark, 60); }, { passive: true });
    // A colour was chosen and its photo moved to the front: show it.
    if ('MutationObserver' in window) {
      new MutationObserver(function () { show(0, true); mark(); }).observe(track, { childList: true });
    }
  });
})();
